module.exports = __webpack_public_path__ + "static/img/tabbt_1.35808f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tabbt_1.png
// module id = HMH+
// module chunks = 1